import { render } from "./NcrmOnboardingHome.vue?vue&type=template&id=60356660"
import script from "./NcrmOnboardingHome.vue?vue&type=script&lang=js"
export * from "./NcrmOnboardingHome.vue?vue&type=script&lang=js"

import "./NcrmOnboardingHome.styles.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__